/**
 * Видимость и порядок колонок в таблице спецификаций.
 *
 * Видимость хранится в cookie (клиент, 365 дней) + на сервере через AJAX (сессия/БД).
 * Порядок пока только на сервере (нет UI для переключения на клиенте).
 */

import { apiRequest } from '../../api.js';
import { state, setCookie, getCookie } from './store.js';

// Колонки сопоставляются по data-col на <th>/<td> (а не по индексу): часть колонок
// (Discount, TotalWithDiscount) условные — индексный маппинг ломался при их скрытии.
export function toggleColumnVisibility(columnName, visible) {
    let found = false;
    document.querySelectorAll('.adm_spec_item_table').forEach(table => {
        table.querySelectorAll(`[data-col="${columnName}"]`).forEach(cell => {
            cell.style.display = visible ? '' : 'none';
            found = true;
        });
    });
    if (!found) return; // колонки нет в DOM (например, скрыта флагом проекта)

    // Пересинхронизировать ширины колонок между таблицами после изменения видимости
    if (window.TableColumnSync) {
        window.TableColumnSync.sync('table[data-sync-columns="spec-rooms"]');
    }
}

async function updateColumnVisibility(columnName, visible) {
    setCookie(`spec_column_${columnName}`, visible ? '1' : '0', 365);
    toggleColumnVisibility(columnName, visible);

    try {
        await apiRequest(`/project/${state.projectId}/spec/column-visibility`, {
            method: 'POST',
            body: { column: columnName, visible },
        });
    } catch (e) {
        console.error('Error updating column visibility:', e);
    }
}

async function updateColumnOrder() {
    const columns = [];
    document.querySelectorAll('#column-visibility .adm_spec_settings_option').forEach((item, index) => {
        const checkbox = item.querySelector('input[type="checkbox"]');
        if (checkbox) columns.push({ name: checkbox.dataset.column, order: index + 1 });
    });

    try {
        await apiRequest(`/project/${state.projectId}/spec/column-order`, {
            method: 'POST',
            body: { columns },
        });
    } catch (e) {
        console.error('Error updating column order:', e);
    }
}

export function applyColumnVisibilitySettings() {
    const checkboxes = document.querySelectorAll('#column-visibility input[type="checkbox"]');
    checkboxes.forEach(checkbox => {
        const columnName = checkbox.dataset.column;
        const savedValue = getCookie(`spec_column_${columnName}`);
        if (savedValue !== null) {
            toggleColumnVisibility(columnName, savedValue === '1');
        }
    });
}

export function initColumnVisibility() {
    const columnVisibility = document.getElementById('column-visibility');
    if (!columnVisibility) return;

    // Применить сохранённые настройки при старте
    columnVisibility.querySelectorAll('input[type="checkbox"]').forEach(checkbox => {
        const columnName = checkbox.dataset.column;
        const savedValue = getCookie(`spec_column_${columnName}`);
        if (savedValue !== null) {
            const isVisible = savedValue === '1';
            checkbox.checked = isVisible;
            toggleColumnVisibility(columnName, isVisible);
        }
    });

    columnVisibility.addEventListener('change', e => {
        if (e.target.type === 'checkbox') {
            updateColumnVisibility(e.target.dataset.column, e.target.checked);
        }
    });

    if (typeof Sortable !== 'undefined') {
        new Sortable(columnVisibility, {
            handle: '.adm_spec_settings_option_dots',
            animation: 150,
            onEnd: updateColumnOrder,
        });
    }
}
